import { IconButton } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import StopIcon from "@mui/icons-material/Stop";
import { useRef, useState } from "react";

const PRIMARY = "#3A54AF";
const SECONDARY = "#f44336";

export default function RecorderButton({ onRecorded }) {
  const mediaRecorder = useRef(null);
  const chunks = useRef([]);
  const [recording, setRecording] = useState(false);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    mediaRecorder.current = new MediaRecorder(stream);

    mediaRecorder.current.ondataavailable = (e) => {
      chunks.current.push(e.data);
    };

    mediaRecorder.current.onstop = () => {
      const blob = new Blob(chunks.current, { type: "audio/webm" });
      chunks.current = [];
      onRecorded(blob);
    };

    mediaRecorder.current.start();
    setRecording(true);
  };

  const stopRecording = () => {
    mediaRecorder.current.stop();
    setRecording(false);
  };

  return (
    <IconButton
      onClick={recording ? stopRecording : startRecording}
      sx={{
        width: 70,
        height: 70,
        borderRadius: "50%",
        background: recording ? SECONDARY : PRIMARY,
        color: "#fff",
        boxShadow: recording
          ? "0 0 0 10px rgba(244,67,54,0.2)"
          : "0 6px 20px rgba(58,84,175,0.3)",
        transition: "all 0.3s ease",
        "&:hover": {
          background: recording ? "#d32f2f" : "#2f4390",
        },
      }}
    >
      {recording ? <StopIcon /> : <MicIcon />}
    </IconButton>
  );
}